import zxcvbn from 'zxcvbn';

export const MIN_PASSWORD_SCORE = 2;
const MIN_PASSWORD_LENGTH = 8;

function zxcvbnScore(password) {
  // zxcvbn is a library used to deteremine password strength
  return zxcvbn(password).score;
}

export function isPasswordWeak(password) {
  return zxcvbn(password).score < MIN_PASSWORD_SCORE;
}

// The server requires a password length of 8 or more
// the zxcvbn only requires 7 to not be a weak password
export function isPasswordShort(password) {
  return password.length < MIN_PASSWORD_LENGTH;
}

export function getPasswordStrength(password) {
  return (isPasswordShort(password) || isPasswordWeak(password)) ? 1 : zxcvbnScore(password);
}
